import * as snapStrategyConst from './constants';
import * as commonRegionService from '../../services/common/region';

export default {
    [snapStrategyConst.getSnapStrategy](state, list) {
        var res = list.AutoSnapshotPolicySet;
        _.map(res, (item) => {

            return item.AutoSnapshotDate = _.invoke(item.AutoSnapshotDate, 'sort');
        });
        state.list = res;
        state.total = (list.AutoSnapshotPolicySet || []).length;
    },
    [snapStrategyConst.validateSnapStra](state, val) {
        state.StraValidate = val.validate;
        state.MaxStraNum = val.AutoSnapshotPolicyInVolumeNum;
    },
    [snapStrategyConst.uniqRequestRegion](state, data) {
        state.uniqRequestRegion = data;
    }
}
